import { render, staticRenderFns } from "./questionWithNoteAndMultiInput.vue?vue&type=template&id=380a2282&"
import script from "./questionWithNoteAndMultiInput.vue?vue&type=script&lang=js&"
export * from "./questionWithNoteAndMultiInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports